import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './i18n' // Initialize i18next before rendering
import './index.css'
import { logger } from '@/utils/logger'
import { config } from '@/config/environment'
import { AuthProvider } from '@/contexts/AuthContext'
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY ?? '')

// Initialize logger with configuration
logger.configure(config.logging)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)